import React, { useEffect, useState } from "react";
import { Page, SubmitButton, required, FormGroup, DatePicker } from "components/common";
import { Control, actions, Errors } from "react-redux-form";
import { NotificationManager } from "react-notifications";
import { useForm, useModal } from "hooks";
import Select from "react-select";
import { isDecimal, isFloat } from "validator";
import { Trans } from "react-i18next";
import { Link } from "react-router-dom";
import { useXeroClient } from "hooks";
import { Input, Col, Row, Table, Button, Badge, UncontrolledCollapse } from "reactstrap";
import BackButton from "components/refactoring/BackButton";
import { BillPayment } from "./Payment";
import { useBaseModal } from "services";
import { useForm as StopForm, Controller } from "react-hook-form"
import InputFile from "components/common/InputFile";
import { HistoryAndNotes } from "components"
import { formatDateName } from "services/util"

const isCurrency = (v) => {
  if (v) {
    return isDecimal(v, { decimal_digits: "0,2" }) && isFloat(v, { min: 0 });
  }
  return false
}

export const LoanEdit = ({
  payroll,
  t,
  url = "loans",
  model = "local",
  history,
  match,
  client,
}) => {
  const { id } = match.params;
  const { dispatch, setValue, Form, save, loaded, load, getTitle, value } =
    useForm({
      model,
    });

  const { control, handleSubmit, register, reset } = StopForm()

  const [employees, setEmployees] = useState([]);
  const [invoice, setInvoice] = useState(null);
  const [accounts, setAccounts] = useState([]);
  const [reload, setReload] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const xero = useXeroClient();

  let status_color = ""
  const [SetStopModal, StopToggle, StopModal] = useBaseModal();
  const [SetCloseModal, CloseToggle, CloseModal] = useBaseModal();

  useEffect(() => {

    async function fetchData() {
      const [item, employees, accounts] = await Promise.all([
        load(payroll, url, id, {
          employee: null,
          description: "",
          date_of_funding: "",
          start_date_of_deduction: "",
          remaining_amount: "",
          pay_slip_lines: [],
          paid: false,
          pay_via_payslips: false,
          Amount: "",
          Date: "",
          Reference: "",
          paid_amount: 0,
          invoice_id: "",
          can_edit:true,
        }),
        payroll
          .get("employees?status=Active&include_all=false")
          .get("data")
          .map((x) => ({
            label: x.full_name,
            value: x.id,
          })),
        xero
          .get("accounts",
            {
              params: {
                raw: `Status="ACTIVE"`,
              },
            })
          .get("data")
      ]);

      id !== "new" && item.invoice_id && item && xero(`invoices/${item.invoice_id}`).then((resp) => {
        setInvoice(resp.data);
      })

      let c_accounts = []

      for (var i = 0; i < accounts.length; i++) {
        // Iterate over numeric indexes from 0 to 5, as everyone expects.
        const el = accounts[i]
        if (el.Type === "BANK") {
          c_accounts.push({
            label: `${el.Name}`,
            value: el.AccountID,
          })
        }
        else {
          c_accounts.push({
            label: `${el.Name} (${el.Code})`,
            value: el.Code,
          })
        }
      }
      setEmployees(employees);
      setAccounts(c_accounts);
      setValue(item);

      let defaultValues = {
        date: (new Date()).toISOString().substring(0, 10),
        account: "615",
        amount: item.remaining_amount,
      }
      reset({ ...defaultValues });
      setIsLoading(false)
    }
    fetchData();
    
  }, [reload, id]);


  if (value) {
    if (value.calculated_status === 'Running') { status_color = "primary"; }
    else if (value.calculated_status === 'Stopped') { status_color = "warning"; }
    else if (value.calculated_status === 'Pending') { status_color = "dark"; }
    else if (value.calculated_status === 'Closed') { status_color = "secondary"; }
    else if (value.calculated_status === 'Rejected') { status_color = "danger"; }
    else { status_color = "success"; }
  }

  const paymentHistory = (value?.history_notes || [])
    .filter((n) => n.changes && (n.changes.paid_amount || n.changes.remaining_amount))
    .map((n) => {
      let amountPaid = null
      let remainingAfter = null

      if (n.changes.paid_amount) {
        const [oldPaid, newPaid] = n.changes.paid_amount
        amountPaid = parseFloat(newPaid) - parseFloat(oldPaid)
        remainingAfter = parseFloat(value.total_amount) - parseFloat(newPaid)
      }

      if (n.changes.remaining_amount) {
        const [oldRemaining, newRemaining] = n.changes.remaining_amount
        remainingAfter = parseFloat(newRemaining)
        if (amountPaid === null) {
          amountPaid = parseFloat(oldRemaining) - parseFloat(newRemaining)
        }
      }

      return {
        id: n.id,
        date: n.timestamp,
        amountPaid,
        remainingAfter,
        recordedBy: n.actor_info?.full_name || t("Auto Generation System"),
      }
    })

  const handleChange = (e) => {
    setValue({ ...value, Amount: e.target.value })
  }
  const handleDateChange = (date) => {
    setValue({ ...value, Date: date })
  }

  const handleFromDate = (event) => {
    setValue({ ...value, stop_deduction_from: event.target.value })
  }

  const handleToDate = (event) => {
    setValue({ ...value, stop_deduction_to: event.target.value })
  }

  const handleClose = async (data) => {
    const { approved, ...rest } = data
    setIsLoading(true)
    payroll.post(`loans/${value.id}/perform_close`, rest).then((resp) => {
      setValue(resp.data)
      setReload((old) => !old)
      CloseToggle()
      setIsLoading(false)
      NotificationManager.success(t("Adjusted successfully"));
    }).catch((err) => {
      NotificationManager.error(t("Unexpected Error Happened"));
      setIsLoading(false)
    })

  }

  async function handleStatusToggle(data, status) {
    const rest = { ...data, status: status }

    try {
      setIsLoading(true)
      const resp = await save(payroll, url, rest);
      setValue(resp.data)
      setIsLoading(false)
      NotificationManager.success(t("stopped successfully"));
      // history.replaceUp();
    } finally {
      SetStopModal(false)
    }
  }

  async function HandleStop(data) {
    if (!data.stop_deduction_from || !data.stop_deduction_to) {
      NotificationManager.error(t("All Fields are required!"));
      return
    }
    handleStatusToggle(data, 'Stopped')
  }

  const handleResume = () => {
    handleStatusToggle({ ...value, stop_deduction_from: null, stop_deduction_to: null }, 'Running')
  }

  async function onSubmit(item, approved = true) {
    if (item.id) {
      item = { ...item, approved: approved }
    }

    try {
      setIsLoading(true)
      const resp = await save(payroll, url, item);
      NotificationManager.success(t("Saved successfully"));
      id === "new" ? history.push(`/payroll/loans/${resp.data.id}`) : setReload(!reload)
    } finally {
      dispatch(actions.setPending(model, false));
    }
  }

  if (!loaded) return null;

  return (
    <Page title={getTitle(id, "Loan")}>
      <BackButton />
      {value &&
        <>
          <StopModal title={t("Stop Deduction")}>
            <div className="d-inline-block">
              <Form onSubmit={HandleStop}>
                <Row>
                  <Col xs="auto">
                    <FormGroup
                      label="From"
                      model=".stop_deduction_from"
                      style={{ width: "9rem" }}
                    >
                      <Input type="date" className="form-control" onChange={(event) => { handleFromDate(event) }} model=".stop_deduction_from" value={value.stop_deduction_from} />
                    </FormGroup>
                  </Col>
                  <Col xs="auto">
                    <FormGroup
                      label="to"
                      model=".stop_deduction_to"
                      style={{ width: "9rem" }}
                    >
                      <Input type="date" className="form-control" onChange={(event) => { handleToDate(event) }} model=".stop_deduction_to" value={value.stop_deduction_to} />
                    </FormGroup>
                  </Col>
                  <Col xs="auto" className="align-self-end">
                    <FormGroup>
                      <Button color="success">
                        <Trans>Save</Trans>
                      </Button>
                    </FormGroup>
                  </Col>
                </Row>
              </Form>
            </div>
          </StopModal>

          <CloseModal title={t("End/Adjust Loan")}>
            <div className="container">
              <form onSubmit={handleSubmit(handleClose)} >
                <Row>
                  <Col className="col-12 my-2">
                    <FormGroup
                      label="Date *">
                      <input type="date" className="form-control" {...register("date", { required: true, maxLength: 20 })} />
                    </FormGroup>
                  </Col>
                  <Col className="col-12 my-2">
                    <FormGroup
                      label="Amount *">
                      <input type="number" step="any" className="form-control" {...register("amount", { required: true, max: value.remaining_amount })} />
                    </FormGroup>
                  </Col>
                  <Col className="col-12 my-2">
                    <FormGroup label="Account *" >
                      <Controller
                        control={control}
                        name={"account"}
                        rules={{ required: true }}
                        render={({ field: { onChange, value, name, ref } }) => {
                          return <Select
                            inputRef={ref}
                            clearable={true}
                            searchable={true}
                            value={accounts.find((c) => c.value === value)}
                            name={name}
                            options={accounts}
                            onChange={(selectedOption) => {
                              onChange(selectedOption?.value);
                            }}
                          />
                        }
                        }
                      />
                    </FormGroup>
                  </Col>
                  <Col className="col-12 d-flex my-2 justify-content-end">
                    <FormGroup>
                      <input type="submit" className="mx-0 btn btn-success" value={t("Adjust/End Loan")} />
                    </FormGroup>
                  </Col>
                </Row>
              </form>
            </div>
          </CloseModal>
          <div className="border p-2 my-2">
            <div className="row justify-content-between align-items-center mb-3">
              <div className="col-8">
                {value.calculated_status && (<h4 className="d-inline-block">
                  <Badge color={status_color} className="font-weight-bold py-2 mr-2"><span className="font-weight-normal"><Trans>Status</Trans></span> ({t(value.calculated_status)})</Badge>
                </h4>)}
                {value.is_paid && (<h4 className="d-inline-block">
                  <Badge color={"success"} className="font-weight-bold py-2"><span className="font-weight-normal"><Trans>Loan Paid</Trans></span></Badge>
                </h4>)}
                {value && value.closed_amount > 0 && <span className="ml-2">*<Trans>Closed amount : </Trans>{value.closed_amount}</span>}
                {value && value.calculated_status === 'Stopped' || value.status === 'Stopped' && <span className="ml-2" style={{ fontSize: "0.7rem" }}>*<Trans>Loan will be paused from </Trans>{value.stop_deduction_from}<Trans> To </Trans>{value.stop_deduction_to}</span>}
              </div>
              <div className="col-4">
                <div className="row justify-content-end align-items-center px-3">
                  {id !== "new" && value.approved && (
                    <>
                      {id !== "new" && value.xero_invoice_id && 
                        <Link to={`/accounts_receivable/invoices/view/${value.xero_invoice_id}`} className="btn btn-info btn-small"><Trans>View Invoice</Trans></Link>
                      }
                      {value.calculated_status !== "Closed" &&
                        <>
                          <div className="col flex-grow-0 px-0">
                            {value.calculated_status === "Stopped" || value.status === "Stopped" ?
                              <Button className="btn btn-info btn-small d-print-none" disabled={value.calculated_status === "Closed" || !value.is_paid} onClick={handleResume}><Trans>Resume</Trans></Button>
                              :
                              <Button className="btn btn-info btn-small d-print-none" disabled={value.calculated_status === "Closed" || !value.is_paid} onClick={() => SetStopModal(true)}><Trans>Stop</Trans></Button>
                            }
                          </div>
                          <div className="col flex-grow-0 px-0">
                            {value.calculated_status != "Closed" && value.status !== value.calculated_status &&
                              <Button className="btn btn-info btn-small d-print-none" disabled={value.calculated_status === "Closed" || !value.is_paid} onClick={() => SetStopModal(true)}><Trans>Edit Stop</Trans></Button>
                            }
                          </div>
                          {value.calculated_status !== "Stopped" &&
                            <div className="col flex-grow-0 px-0">
                              <Button className="ml-1 mr-0 btn btn-danger" disabled={value.calculated_status === "Closed" || !value.is_paid} onClick={() => { SetCloseModal(true) }}><Trans>End/Adjust</Trans></Button>
                            </div>
                          }
                        </>
                      }
                    </>
                  )}
                </div>

              </div>

            </div>

            <Row>
              <Col md="12">
                <Form
                  onSubmit={onSubmit}
                  validators={{
                    employee: { required },
                    description: { required },
                    date_of_funding: { required },
                    start_date_of_deduction: { required },
                    total_amount: { isCurrency },
                    deduction_amount: (v) => (value.id ? (v <= parseFloat(value?.remaining_amount)) : true),
                    remaining_amount: (v) => (value.id ? isCurrency(v) : true),

                  }}
                >
                  <Row>
                    <Col>
                      <FormGroup className="pb-3" label="Employee *" model=".employee" addControlClass={false}>
                        <Control.text style={{ backgroundColor: '#F4F7FE' }}
                          model=".employee"
                          component={Select}
                          options={employees}
                          simpleValue
                          clearable={false}
                          disabled={!value.can_edit}
                        />
                        <Errors
                          className="form-text small text-danger"
                          model=".employee"
                          show="touched"
                          messages={{
                            required: t("this field is required")
                          }}
                        />
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup className="pb-3 text-nowrap" label="Total Amount *" model=".total_amount">
                        <Control.text
                          model=".total_amount"
                          disabled={!value.can_edit}
                          onChange={handleChange}
                        />
                        <Errors
                          className="form-text small text-danger"
                          model=".total_amount"
                          show="touched"
                          messages={{
                            required: t("this field is required")
                          }}
                        />
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup className="pb-3 text-nowrap" label="Monthly Deduction *" model=".deduction_amount">
                        <Control.text model=".deduction_amount" disabled={value.calculated_status === "Closed"} />
                        <Errors
                          className="form-text small text-danger"
                          model=".deduction_amount"
                          show="touched"
                          messages={{
                            required: t("this field is required")
                          }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormGroup className="pb-3 text-nowrap" label="Date of Funding *" model=".date_of_funding">
                        <DatePicker type="date" className="form-control" model=".date_of_funding" onChange={(date) => { handleDateChange(date) }} disabled={!value.can_edit} />
                        <Errors
                          className="form-text small text-danger"
                          model=".date_of_funding"
                          show="touched"
                          messages={{
                            required: t("this field is required")
                          }}
                        />
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup className="pb-3 text-nowrap" label="Start Date of Deduction *" model=".start_date_of_deduction" >
                        <DatePicker type="date" className="form-control" model=".start_date_of_deduction" disabled={!value.can_edit} />
                        <Errors
                          className="form-text small text-danger"
                          model=".start_date_of_deduction"
                          show="touched"
                          messages={{
                            required: t("this field is required")
                          }}
                        />
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup className="pb-3 text-nowrap" label="Reason *" model=".description" >
                        <Control.text model=".description" disabled={!value.can_edit} />
                        <Errors
                          className="form-text small text-danger"
                          model=".description"
                          show="touched"
                          messages={{
                            required: t("this field is required")
                          }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row className="align-items-start">
                    {!!value.id && (
                      <Col className="col-4">
                        <FormGroup label="Remaining Amount *" model=".remaining_amount">
                          <Control.text
                            model=".remaining_amount" disabled={!value.can_edit}
                          />
                        </FormGroup>
                      </Col>
                    )}
                    <Col className="col-4">
                      <FormGroup className="pb-2">
                        <label htmlFor=""><Trans>Attachment</Trans></label>
                        <InputFile t={t} file={value.attachment || ""} setData={setValue}></InputFile>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row className="my-2">
                    <Col className="col-6">
                      <FormGroup label="Pay via Payslips" model=".pay_via_payslips" className="form-g-check" >
                        <Control.checkbox
                          model=".pay_via_payslips"
                          // onChange={() => { showPayment() }}
                          className="ml-2 rtl-paid-checkbox" disabled={value.is_paid}
                        />
                      </FormGroup>
                    </Col>
                    <Col className="col-6">
                      <FormGroup label="Opening Balance" model=".is_opening_balance" className="form-g-check" >
                        <Control.checkbox
                          model=".is_opening_balance"
                          // onChange={() => { showPayment() }}
                          className="ml-2 rtl-paid-checkbox" disabled={!value.can_edit ||!!value.xero_invoice_id}
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  {/* {value.is_paid === true &&
                    <div className="d-flex justify-content-start d-print-none my-3" >
                      <button className="border-0 p-1" style={{ backgroundColor: "#72B566", color: "white" }} disabled={value.calculated_status === "Closed"}> <Trans>Paid</Trans></button>
                    </div>
                  } */}
                  <div className="d-flex justify-content-end d-print-none my-3">
                    <SubmitButton disabled={isLoading ||value.calculated_status === "Closed"} onClick={(e) => { onSubmit(value, true) }}> <Trans>{match.params.id === "new" ? "Create" : value.approved ? "Update" : "Approve"}</Trans></SubmitButton>
                    {value.calculated_status === "Pending" && <SubmitButton disabled={isLoading} color="danger" onClick={(e) => { onSubmit(value, false) }} className="mx-2"> <Trans>Reject</Trans></SubmitButton>}
                  </div>
                </Form>
              </Col>
            </Row>
          </div>
          {id !== "new" && value.xero_invoice_id && !value.pay_via_payslips && !value.is_paid &&
            <div className="pay border p-2 my-2">
              <div className="d-inline-block my-2">
                <BillPayment payroll={payroll} t={t} url={`loans/${id}/pay_loan`} amount={value?.total_amount - value?.paid_amount} setReload={setReload} key={value?.paid_amount}></BillPayment>
              </div>
            </div>
          }
          {invoice &&
            <div className="payments border mt-2">
              <button className="btn btn-link link text-success shadow-none py-3" id="payments">
                <h5 className="mb-0"><i className="fas fa-angle-right mx-1"></i><Trans>Loan Bill History</Trans></h5>
              </button>
              <UncontrolledCollapse toggler="#payments">
                <Table size="sm" className="inv-table my-0">
                  <thead>
                    <tr>
                      <th className="border-0"><Trans>Reference</Trans></th>
                      {/* <th className="border-0">Pay Run Date</th> */}
                      <th className="border-0"><Trans>Date</Trans></th>
                      <th className="border-0"><Trans>Amount</Trans></th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoice.Payments?.map((i, index) => (
                      <tr key={index}>
                        <td>
                          <Link to={`/payments/${i.PaymentID}`}>
                            <Trans>Payment : </Trans>{i.Reference || "-"}
                          </Link>
                        </td>
                        {/* <td >
                      {formatDate(i.end_date)}
                  </td> */}
                        <td>{i.Date?.slice(0, 10)}</td>
                        <td>{i.Amount}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </UncontrolledCollapse>
            </div>
          }
          {paymentHistory.length > 0 &&
            <div className="payments border mt-2">
              <button className="btn btn-link link text-success shadow-none py-3" id="loan-payment-history">
                <h5 className="mb-0"><i className="fas fa-angle-right mx-1"></i><Trans>Payment History</Trans></h5>
              </button>
              <UncontrolledCollapse toggler="#loan-payment-history">
                <Table size="sm" className="inv-table my-0">
                  <thead>
                    <tr>
                      <th className="border-0"><Trans>Date</Trans></th>
                      <th className="border-0"><Trans>Amount Paid</Trans></th>
                      <th className="border-0"><Trans>Recorded By</Trans></th>
                      <th className="border-0"><Trans>Remaining Balance</Trans></th>
                    </tr>
                  </thead>
                  <tbody>
                    {paymentHistory.map((i, index) => (
                      <tr key={i.id || index}>
                        <td>{formatDateName(i.date)}</td>
                        <td>{i.amountPaid !== null ? i.amountPaid.toFixed(2) : "-"}</td>
                        <td>{i.recordedBy}</td>
                        <td>{i.remainingAfter !== null ? i.remainingAfter.toFixed(2) : "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </UncontrolledCollapse>
            </div>
          }
          <div className="payments border mt-2">
            <button className="btn btn-link link text-success shadow-none py-3" id="payruns">
              <h5 className="mb-0"><i className="fas fa-angle-right mx-1"></i><Trans>Payrun Deductions</Trans></h5>
            </button>
            <UncontrolledCollapse toggler="#payruns">
              <Table size="sm" className="inv-table my-0">
                <thead>
                  <tr>
                    <th className="border-0"><Trans>Pay RUN SN</Trans></th>
                    {/* <th className="border-0">Pay Run Date</th> */}
                    <th className="border-0"><Trans>Type</Trans></th>
                    <th className="border-0"><Trans>Status</Trans></th>
                    <th className="border-0"><Trans>Amount</Trans></th>
                  </tr>
                </thead>
                <tbody>
                  {value?.pay_slip_lines?.map((i, index) => (
                    <tr key={index}>
                      <td>
                        <Link to={`/payroll/pay_runs/${i.pay_slip__pay_run}/pay_slips/${i.pay_slip}`}>
                          {i.pay_run_serial_number}
                        </Link>
                      </td>
                      {/* <td >
                        {formatDate(i.end_date)}
                    </td> */}
                      <td>{i.subtype}</td>
                      <td>{i.payrun_status}</td>
                      <td>{i.amount}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </UncontrolledCollapse>
          </div>

          <hr />

          <HistoryAndNotes
            item={value}
            contentType={'loan'}
            client={client}
            t={t}
          />
        </>
      }
    </Page>
  );
};

export default LoanEdit;
